export const modules = [
  {
    key: 'batch',
    label: 'Batch',
    to: '/batch',
    children: [],
  },
  {
    key: 'ftp',
    label: 'Full Time Program',
    to: '/ftp/applicants',
    children: [
      { label: 'Applicants', to: '/ftp/applicants' },
      { label: 'Students', to: '/ftp/students' },
    ],
  },
  {
    key: 'ptp',
    label: 'Part Time Program',
    to: '/ptp/applicants',
    children: [
      { label: 'Applicants', to: '/ptp/applicants' },
      { label: 'Students', to: '/ptp/students' },
    ],
  },
];

export const applicantTabs = [
  { slug: 'personal-data', label: 'Personal Data' },
  { slug: 'test-history', label: 'Test History', ftpOnly: true },
  { slug: 'history-call', label: 'History Call' },
  { slug: 'activity-log', label: 'Activity Log' },
  { slug: 'move-batch', label: 'Move Batch' },
  { slug: 'payment-detail', label: 'Payment Detail' },
];
